// ── TmContracts — 계약현황 (본인 계약 목록) ──────────────────────────────────

import React, { useEffect, useState, useCallback } from 'react';
import { apiClient } from '../../api/apiClient';
import { useToast } from '../../components/Toast';
import TmContractsList from './TmContractsList';

// ── 메인 컴포넌트 ─────────────────────────────────────────────────────────────
export default function TmContracts() {
  const toast = useToast();
  const [rows,    setRows]    = useState([]);
  const [loading, setLoading] = useState(true);

  // 모바일 감지 (768px 기준)
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  // ── 계약 목록 조회 ─────────────────────────────────────────────────────────
  const fetchContracts = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiClient.get('/api/tm/my-contracts');
      if (res.data?.success) setRows(res.data.data || []);
      else toast.error(res.data?.message || '계약 목록을 불러오지 못했습니다.');
    } catch (err) {
      toast.error(err.response?.data?.message || '계약 목록 조회 실패');
    } finally {
      setLoading(false);
    }
  }, [toast]);

  useEffect(() => { fetchContracts(); }, [fetchContracts]);

  return (
    <div style={{ padding: '20px 0', width: '100%', overflow: 'hidden', minWidth: 0 }}>
      {/* ── 헤더 ──────────────────────────────────────────────────────── */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: 'var(--text)' }}>계약현황</h2>
        <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>
          {loading ? '불러오는 중...' : `${rows.length}건`}
        </span>
      </div>
      {/* ── 목록 ──────────────────────────────────────────────────────── */}
      <TmContractsList rows={rows} loading={loading} isMobile={isMobile} />
    </div>
  );
}
